
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/walkthrough",
      function () {
        return require("private-next-pages/walkthrough.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/walkthrough"])
      });
    }
  